export const PIPEFY_PAST_START_DATE_MESSAGE =
  'Não é possível enviar ao Pipefy porque a data de início da promoção é anterior ao dia atual.';

function toDateKey(year: number, month: number, day: number): string | null {
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) return null;

  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function parsePromotionDateKey(value: unknown): string | null {
  const normalized = String(value ?? '').trim();
  const brDate = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\D|$)/);
  if (brDate) return toDateKey(Number(brDate[3]), Number(brDate[2]), Number(brDate[1]));

  const isoDate = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:\D|$)/);
  if (isoDate) return toDateKey(Number(isoDate[1]), Number(isoDate[2]), Number(isoDate[3]));

  return null;
}

function getLocalDateKey(now: Date): string | null {
  if (!(now instanceof Date) || Number.isNaN(now.getTime())) return null;
  return toDateKey(now.getFullYear(), now.getMonth() + 1, now.getDate());
}

export function isPromotionStartDateInPast(value: unknown, now = new Date()): boolean {
  const startDateKey = parsePromotionDateKey(value);
  const todayKey = getLocalDateKey(now);
  return Boolean(startDateKey && todayKey && startDateKey < todayKey);
}
